<app-loading></app-loading>

<router-outlet></router-outlet>

<p-toast></p-toast>